module.exports = __webpack_public_path__ + "static/media/POPCORN_0.52fafcd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/POPCORN_0.png
// module id = 183
// module chunks = 0